import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Autocomplete, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";

import { Mode } from "constants/enum";
import { ICodename, IDataDetailReport, IErrorReport } from "commons/interfaces";



const CardClassifyByHospital = ({
    mode,
    data,
    error,
    dataOptions,
    handleChangeValue,
}: {
    mode: Mode,
    error: IErrorReport;
    data: IDataDetailReport;
    handleChangeValue: (key: string, value: any) => void;
    dataOptions: {
        byHospital: ICodename[];
        byHospitalSource: ICodename[];
    };
}) => {

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.REPORT.CLASSIFY_BY_HOSPITAL}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.byHospitalSource}
                        label={Strings.REPORT.SOURCE_REPORT}
                        defaultValue={data?.byHospitalSource}
                        errorMessage={error?.byHospitalSource}
                        placeholder={Strings.REPORT.SELECT_SOURCE_REPORT}
                        onChange={(val) => {
                            handleChangeValue("byHospitalSource", val)
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.byHospital}
                        defaultValue={data?.byHospital}
                        errorMessage={error?.byHospital}
                        label={Strings.REPORT.HOSPITAL_CLASS}
                        placeholder={Strings.REPORT.SELECT_HOSPITAL_CLASS}
                        onChange={(val) => {
                            handleChangeValue("byHospital", val)
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
}

export default CardClassifyByHospital;